






























import { Vue, Component } from "vue-property-decorator"
import { Howl } from "howler"
@Component
export default class GameMetadataView extends Vue {
  get timer() {
    return this.$store.state.timeStr
  }

  get roundNum() {
    return this.$store.getters.activeRound
  }

  protected togglePlayPause() {
    if (
      // !this.$store.state.paused &&
      !this.$store.state.tutorial &&
      !this.$store.state.introScreen &&
      !this.$store.getters.event
    ) {
      if (this.$store.state.paused) {
        this.$store.dispatch("unpause")
      } else {
        this.$store.dispatch("pause")
      }
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }

  protected toggleMute() {
    if (
      !this.$store.state.paused &&
      !this.$store.state.tutorial &&
      !this.$store.state.introScreen &&
      !this.$store.getters.event
    ) {
      this.$store.dispatch("toggleMute")
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }

  protected modGameSpeed(val: number) {
    if (
      !this.$store.state.paused &&
      !this.$store.state.tutorial &&
      !this.$store.state.introScreen &&
      !this.$store.getters.event
    ) {
      this.$store.dispatch("modGameSpeed", val)
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }

  protected hurry() {
    this.$store.dispatch("nullTimer")
  }

  protected start() {
    if (
      !this.$store.state.paused &&
      !this.$store.state.tutorial &&
      !this.$store.state.introScreen &&
      !this.$store.getters.event
    ) {
      this.$store.dispatch("beginRound")
    }
  }

  protected openBook() {
    if (
      !this.$store.state.tutorial &&
      !this.$store.state.introScreen &&
      !this.$store.getters.event
    ) {
      this.$store.dispatch("toggleBook")
      if (!this.$store.state.muted) {
        new Howl({
          src: ["/audio/Click.mp3"]
        }).play()
      }
    }
  }

  get gameSpeed() {
    return this.$store.state.roundSpeed
  }

  get maxDay() {
    return this.$store.state.daysPerRound
  }

  get currentDay() {
    if (this.$store.state.rounds != null) {
      return this.$store.state.rounds[this.roundNum - 1].day
    } else {
      return 1
    }
  }
}
